import React, { useState, useEffect } from 'react';
import ConsultationSection from '../components/ConsultationSection';
import ReviewsBar from '../components/ReviewsBar';
import './TajweedCourse.css';
import '../components/WhoWeAre.css';
import '../components/AdultsAndJourney.css';
import '../components/AboutFeatures.css';
import '../components/FAQSection.css';
import CertifiedTutors from '../components/CertifiedTutors';

const TajweedCourse = () => {
  const [rotation, setRotation] = useState(0);
  const [faqOpenStates, setFaqOpenStates] = useState({ 'tj-left-0': true });

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setRotation(scrollY * 0.15);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return (
    <div className="tajweed-course-page">
      {/* 1. Hero Breadcrumb Section */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')` }}
      >
        <div className="about-hero__content">
          <h1 className="about-hero__title">Learn Quran with Tajweed Online</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">
              Home
            </a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Tajweed Course</span>
          </nav>
        </div>
      </section>



      {/* 2. Two-Column Intro Section */}
      <section className="tajweed-intro-section">
        <div className="tajweed-intro__container">
          {/* Left Column: Text Content */}
          <div className="tajweed-intro__text-col">
            <h2 className="tajweed-intro__title">
              Online Tajweed Course From the Best Online Quran Academy
            </h2>
            <p className="tajweed-intro__desc">
              Our Online Tajweed course provides a way to learn the Quran with Tajweed online with our expert-led Tajweed course. If you're a beginner or looking to improve your pronunciation, our Quran tajweed classes are designed to give you good teaching with accurate recitation. Many students from the USA use our platform on a regular basis to enhance their Quran skills and develop their connection with the Holy Book through our <a href="/" className="green-link">online Quran classes</a>. Our teaching style is attractive, practical, and perfect for all ages. Our Quran tajweed classes are best for everyone who is looking to improve their Quran recitation with proper tajweed rules, including beginners, housewives, and old people. We have a proven track record of teaching many digital courses with reliable tutors to help you recite the Quran with exact pronunciation, plus fluency.
            </p>
            <div className="tajweed-intro__cta">
              <a href="/free-trial/" className="tajweed-intro__btn">
                Get 3 Days Free Trial Today
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="tajweed-intro__btn-arrow">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="tajweed-intro__image-col">
            <div className="tajweed-intro__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/g-5.jpg`}
                alt="Online Quran Tajweed Course"
                className="tajweed-intro__img"
                style={{
                  WebkitMaskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                  WebkitMaskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  WebkitMaskRepeat: 'no-repeat',
                  maskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                  maskSize: 'contain',
                  maskPosition: 'center',
                  maskRepeat: 'no-repeat'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* 3. Special Features Section */}
      <section className="tajweed-special-section">
        <div className="tajweed-special__container">
          <h2 className="tajweed-special__title">
            What Makes Our Online Tajweed Course Special?
          </h2>
          <div className="tajweed-special__grid">
            {/* Card 1 */}
            <div className="tajweed-special__card">
              <div className="tajweed-special__card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" className="tajweed-special__card-icon-svg">
                  <path fill="#006100" d="M96 0C43 0 0 43 0 96V416c0 53 43 96 96 96H384h32c17.7 0 32-14.3 32-32s-14.3-32-32-32V384c17.7 0 32-14.3 32-32V32c0-17.7-14.3-32-32-32H384 96zm288 96v256H96c-17.7 0-32-14.3-32-32s14.3-32 32-32H384V96z" />
                </svg>
              </div>
              <h3 className="tajweed-special__card-title">Live One-on-One Education</h3>
              <p className="tajweed-special__card-desc">
                We introduced online tajweed classes on the Quran that are meant to justify every single learning parameter of each student. Students receive proper attention during focused one-on-one instruction, which provides greater understanding and faster ability to succeed.
              </p>
            </div>

            {/* Card 2 */}
            <div className="tajweed-special__card">
              <div className="tajweed-special__card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" className="tajweed-special__card-icon-svg">
                  <path fill="#006100" d="M192 352c53 0 96-43 96-96V96c0-53-43-96-96-96S96 43 96 96v160c0 53 43 96 96 96zm160-96c0-8.8-7.2-16-16-16s-16 7.2-16 16v16c0 70.6-57.4 128-128 128S64 342.6 64 272v-16c0-8.8-7.2-16-16-16S32 247.2 32 256v16c0 81.9 61.7 150 141.6 160.2l-13.6 54.4H112c-8.8 0-16 7.2-16 16s7.2 16 16 16h160c8.8 0 16-7.2 16-16s-7.2-16-16-16h-48l-13.6-54.4C302.3 422 352 353.9 352 272v-16z" />
                </svg>
              </div>
              <h3 className="tajweed-special__card-title">Qualified Male and Female Tutors</h3>
              <p className="tajweed-special__card-desc">
                We provide highly qualified male and female tutors who possess extensive knowledge in Tajweed. Comfort, trust, and a successful learning experience are ensured by permitting students to select the instructor of their choice.
              </p>
            </div>

            {/* Card 3 */}
            <div className="tajweed-special__card">
              <div className="tajweed-special__card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="tajweed-special__card-icon-svg">
                  <path fill="#006100" d="M224 96C135.6 96 64 167.6 64 256c0 23.3 5 45.4 14 65.5L43.8 368c-10 14.8-1.5 35 16.3 37.8l50.6 8.1c25 21.2 56.6 34.1 91.3 34.1c11.9 0 23.4-1.3 34.5-3.8V99.7C233.9 97.3 229 96 224 96zm254.2 272L444 321.5c9-20.1 14-42.2 14-65.5c0-88.4-71.6-160-160-160c-5 0-9.9 1.3-14.5 3.7v344.5c11.1 2.5 22.6 3.8 34.5 3.8c34.7 0 66.3-12.9 91.3-34.1l50.6-8.1c17.8-2.8 26.3-23 16.3-37.8z" />
                </svg>
              </div>
              <h3 className="tajweed-special__card-title">Flexible Schedules & Wide Access</h3>
              <p className="tajweed-special__card-desc">
                We provide flexible class schedules to fit your schedule, whether you're in the USA, UK, or Canada. With our convenient online platform, you can learn the Quran Tajweed course online that is best for you from anywhere in the world.
              </p>
            </div>
          </div>
        </div>
      </section>


      {/* Reviews Bar Section */}
      <ReviewsBar />

      {/* 4. Best Online Tajweed Course Section (Who We Are style) */}
      <section
        className="who-we-are"
        id="tajweed-who-we-are"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
        }}
      >
        <div className="who-we-are__container">
          {/* Left Column: Overlapping Images */}
          <div className="who-we-are__images-wrapper">
            {/* Rotating Stamp */}
            <div
              className="who-we-are__stamp"
              style={{ transform: `rotate(${rotation}deg)` }}
            >
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/G-3.webp`}
                alt="Certified Quran Academy Stamp"
                className="who-we-are__stamp-img"
              />
            </div>

            {/* Top Image */}
            <div className="who-we-are__img-container who-we-are__img-container--top">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/BG-3.jpg`}
                alt="Online Quran Classes For Kids"
                className="who-we-are__main-img"
              />
            </div>

            {/* Bottom Image */}
            <div className="who-we-are__img-container who-we-are__img-container--bottom">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/wmremove-transformed-2.jpeg`}
                alt="Online Quran Classes For Kids"
                className="who-we-are__main-img"
              />
            </div>
          </div>

          {/* Right Column: Text & Content */}
          <div className="who-we-are__content">
            <h3 className="who-we-are__subtitle">
              <svg aria-hidden="true" className="who-we-are__subtitle-icon" viewBox="0 0 640 512" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
              </svg>
              <span>Online Tajweed Classes</span>
            </h3>

            <h2 className="who-we-are__title">
              Best Online Tajweed Course For Kids and Adults
            </h2>

            <p className="who-we-are__paragraph">
              Our online Tajweed course is suitable for both children and adults, with clear lessons for all age groups and levels. Students learn proper pronunciation methods step by step, gradually boosting their reciting skills. If you are just starting or want to improve your skills, our Quran recitation classes make Quran study simple and engaging for everyone. Our online Tajweed classes use visuals and go through methods to make learning enjoyable for younger students.
            </p>

            <p className="who-we-are__paragraph">
              Our goal is to ensure that learning the Quran with Tajweed rules is easy, joyful, and reliable. Every course is thoughtfully created, utilizing live sessions and contemporary tools to ensure immediate response. While adults gain from the ease and depth of learning, parents value our structured approach for children. Get expert help to begin your Tajweed classes right now. For adults, our online Tajweed courses go over the rules in great detail, making sure that each letter is articulated clearly.
            </p>

            <div className="who-we-are__contacts">
              <a href="tel:+17164577657" className="who-we-are__contact-item">
                <div className="who-we-are__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="who-we-are__contact-svg">
                    <path d="M6.62 10.79a15.15 15.15 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.27 11.72 11.72 0 003.7.59 1 1 0 011 1V20a1 1 0 01-1 1A17 17 0 013 4a1 1 0 011-1h3.5a1 1 0 011 1 11.72 11.72 0 00.59 3.7 1 1 0 01-.27 1.11z" />
                  </svg>
                </div>
                <div className="who-we-are__contact-text">
                  <span className="who-we-are__contact-label">Call Us Anytime</span>
                  <span className="who-we-are__contact-value">(716) 457-7657</span>
                </div>
              </a>

              <a href="mailto:info@alquranlesson.com" className="who-we-are__contact-item">
                <div className="who-we-are__contact-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="who-we-are__contact-svg">
                    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
                  </svg>
                </div>
                <div className="who-we-are__contact-text">
                  <span className="who-we-are__contact-label">Email Us Anytime</span>
                  <span className="who-we-are__contact-value">info@alquranlesson.com</span>
                </div>
              </a>
            </div>

            <div className="who-we-are__actions" style={{ display: 'flex', flexWrap: 'wrap', gap: '16px', marginTop: '28px' }}>
              <a href="/free-trial/" className="who-we-are__btn" style={{ textDecoration: 'none' }}>
                <span>Claim Your Free Trial</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="who-we-are__btn-icon">
                  <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z" />
                </svg>
              </a>

              <button
                onClick={() => {
                  window.dispatchEvent(new CustomEvent('open-chat'));
                  if (typeof window.openChatbot === 'function') {
                    window.openChatbot();
                  }
                }}
                className="who-we-are__btn who-we-are__btn--secondary"
                style={{
                  backgroundColor: '#0b2a18',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '40px',
                  padding: '16px 32px',
                  fontSize: '16px',
                  fontWeight: '700',
                  cursor: 'pointer',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '10px',
                  boxShadow: '0 10px 20px rgba(11, 42, 24, 0.2)',
                  transition: 'all 0.3s ease'
                }}
              >
                <span>Speak Live With Experts</span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '18px', height: '18px' }}>
                  <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </section >



      {/* 5. Mid CTA Banner */}
      < section
        className="tajweed-mid-cta"
        style={{
          '--cta-bg-url': `url('${process.env.PUBLIC_URL}/assets/images/hero-bottom.webp')`
        }}
      >
        <div className="mid-cta-grid">
          <div className="mid-cta-text">
            <h2>Get 3 Days Free Trial & Start Learning Online Quran With Tajweed!</h2>
            <a href="/free-trial/" className="btn-yellow-cta">
              Book Your 3-Day Free Trial
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '18px', height: '18px', marginLeft: '6px', display: 'inline-block', verticalAlign: 'middle' }}>
                <path d="M16.01 11H4v2h12.01v3L20 12l-3.99-4v3z" />
              </svg>
            </a>
          </div>
          <div className="mid-cta-image">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/course1/img-1.png`}
              alt="Get 3 Days Free Trial & Start Learning Online Quran With Tajweed!"
            />
          </div>
        </div>
      </section >

      {/* 4.5. Why Learning Tajweed Is Necessary Section */}
      < section className="tajweed-necessity-section" >
        <div className="tajweed-intro__container">
          {/* Left Column: Text Content */}
          <div className="tajweed-intro__text-col">
            <h2 className="tajweed-intro__title">
              Why Learning Quran With Tajweed Is Necessary?
            </h2>
            <p className="tajweed-intro__desc">
              The Quran was revealed in a unique dialect of the Prophet (PBUH), which indicated that it is not merely an ordinary speech. Allah SWT says in the Quran while describing the importance of Tajweed rules: “Or add to it, and recite the Qur’an with measured recitation”(73:4). This is a reminder of the necessity for Quran Tajweed rules because all of this happens by pronouncing each word and even letter properly. The Prophet Muhammad (PBUH) added to the significance of Tajweed by saying: “The one who is proficient in the recitation of the Quran will be with the honorable and obedient scribes (angels). And the one who recites the Quran and finds it difficult, and it is hard for him, will have a double reward.” (Sahih Muslim). To ensure humans do not make such mistakes is explained that a single wrong letter can change the meaning of the verse, so from here comes tajweed. With these rules of reciting, the beauty and sanctity of this act as an expression that connects him or her spiritually to the divine word is maintained.
            </p>
            <div className="tajweed-intro__cta">
              <a href="/free-trial/" className="tajweed-intro__btn">
                Get 3 Days Free Trial Today
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="tajweed-intro__btn-arrow">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="tajweed-intro__image-col">
            <div className="tajweed-intro__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/teach-quran-noorani-qaida-and-arabic-30-minutes-per-day.webp`}
                alt="Online Quran Tajweed Course"
                className="tajweed-intro__img"
                style={{
                  WebkitMaskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                  WebkitMaskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  WebkitMaskRepeat: 'no-repeat',
                  maskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                  maskSize: 'contain',
                  maskPosition: 'center',
                  maskRepeat: 'no-repeat'
                }}
              />
            </div>
          </div>
        </div>
      </section >

      {/* 4.7. Advantages of Tajweed Section */}
      < section className="tajweed-advantages-section" >
        <div className="tajweed-advantages__container">
          <div className="tajweed-advantages__header">
            <h2>The Advantages Of Learning the Quran with Tajweed Online From Knowledgeable Tutors</h2>
            <div className="tajweed-advantages__underline"></div>
          </div>

          <div className="tajweed-advantages__layout">
            {/* Left Column: Cards */}
            <div className="tajweed-advantages__left">
              {/* Card 1 */}
              <div className="tajweed-advantages__card">
                <div className="tajweed-advantages__card-icon">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/course1/C-1.webp`} alt="Learn Quran with Fluency" />
                </div>
                <div className="tajweed-advantages__card-content">
                  <h3>Fluency and Proper Accent</h3>
                  <p>
                    In the Quran, every word holds a different meaning as per the requirement, so it is very important to pronounce it correctly per Tajweed terms and also get education about it with good teachers. People become more confident and clear, reciting the Quran perfectly and respectfully. This fine and authentic recitation makes your religious connections and stays clear of minor mistakes that could change the meaning of the Quranic verses.
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="tajweed-advantages__card">
                <div className="tajweed-advantages__card-icon">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/course1/A-2.webp`} alt="Learn Quran with Proper Pronunciation and Tajweed" />
                </div>
                <div className="tajweed-advantages__card-content">
                  <h3>Obtaining Better Acceptance Of Verses</h3>
                  <p>
                    Using Tajweed guidelines makes each stanza clearer and easier to read, which helps students focus on the themes. A disciplined recitation allows pupils to engage spiritually and intellectually with the Quran. Understanding the message becomes more natural when each sound is provided as it should be. That is the best advantage of learning the Quran with Tajweed online from experienced tutors.
                  </p>
                </div>
              </div>

              {/* Card 3 */}
              <div className="tajweed-advantages__card">
                <div className="tajweed-advantages__card-icon">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/course1/A-3.webp`} alt="Confident Quran Recitation" />
                </div>
                <div className="tajweed-advantages__card-content">
                  <h3>Confident Quran Recitation</h3>
                  <p>
                    Our Quran recitation classes are intended to increase confidence. Student do better in their tajweed and qirat, they are excited to recite in public or competitions, during prayers (taraweeh), or at family gatherings for a token of appreciation. Confidence starts with constant practice and guidelines, assisting students in authentic pronunciation and developing a strong, clear, and respectful Quranic voice.
                  </p>
                </div>
              </div>

              {/* Card 4 */}
              <div className="tajweed-advantages__card">
                <div className="tajweed-advantages__card-icon">
                  <img src={`${process.env.PUBLIC_URL}/assets/images/course1/A-4.webp`} alt="Quran Classes Free Trial" />
                </div>
                <div className="tajweed-advantages__card-content">
                  <h3>Assessments, Monitoring and Input</h3>
                  <p>
                    Regular assessments of Quran reading with tajweed permit tutors to keep a close eye on students' progress. Appreciation towards teachers from parents is very encouraging. Teachers and parents must collaborate in this regard, ensuring that children receive helpful feedback and praise, motivating them to learn more.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column: Image */}
            <div className="tajweed-advantages__right">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/course1/A10.jpg`}
                alt="Online Quran Tajweed Course - Al Quran Lesson"
                className="tajweed-advantages__img"
              />
            </div>
          </div>
        </div>
      </section >

      {/* 4.8. Objectives Section */}
      < section className="tajweed-intro-section" id="tajweed-objectives" >
        <div className="tajweed-intro__container">
          {/* Left Column: Text Content */}
          <div className="tajweed-intro__text-col">
            <h2 className="tajweed-intro__title">
              Our Online Tajweed Course Objectives: What You'll Get
            </h2>
            <p className="tajweed-intro__desc">
              You will get a strong foundation in Arabic vocalization, become an expert in reciting verses, and understand the fundamentals of Tajweed by signing up for our online Quran learning with Tajweed to learn the Quran with Tajweed. The incredible confidence is what you get as the ability to read independently, and memorizing the information is another goal of the training. We make a safe space for students and teachers so the students receive proper guidelines, questions and answers, and appreciative words from teachers as they progress from basic concepts to more advanced levels. It is easy to read the Quran by the end of the course; mark the usual mistakes that also misinterpret its meaning. Also, our students learn more than just how to recite the Quran; they also develop a deeper understanding of its message.
            </p>
            <div className="tajweed-intro__cta">
              <a href="/free-trial/" className="tajweed-intro__btn">
                Get 3 Days Free Trial Today
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="tajweed-intro__btn-arrow">
                  <path fillRule="evenodd" d="M3 10a.75.75 0 01.75-.75h10.638L10.22 5.03a.75.75 0 111.06-1.06l5.5 5.5a.75.75 0 010 1.06l-5.5 5.5a.75.75 0 11-1.06-1.06l4.168-4.17H3.75A.75.75 0 013 10z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="tajweed-intro__image-col">
            <div className="tajweed-intro__image-wrapper">
              <img
                src={`${process.env.PUBLIC_URL}/assets/images/about1.jpg`}
                alt="Learn Quran With Tajweed Online - Al Quran Lesson"
                className="tajweed-intro__img"
                style={{
                  WebkitMaskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                  WebkitMaskSize: 'contain',
                  WebkitMaskPosition: 'center',
                  WebkitMaskRepeat: 'no-repeat',
                  maskImage: `url('${process.env.PUBLIC_URL}/assets/images/online-quran-classes-canada/masking.webp')`,
                  maskSize: 'contain',
                  maskPosition: 'center',
                  maskRepeat: 'no-repeat'
                }}
              />
            </div>
          </div>
        </div>
      </section >

      {/* 4.75. Major Modules Section */}
      < section className="tajweed-modules-section" >
        <div className="tajweed-modules__container">
          <div className="tajweed-modules__header">
            <h2>Major Modules Of Our Online Quran Tajweed Course</h2>
            <p>Our online Tajweed course follows an organized curriculum that is suitable for both beginners and intermediate students. The modules contain:</p>
            <div className="tajweed-modules__underline"></div>
          </div>

          <div className="tajweed-modules__layout">
            {/* Left Column: Modules List */}
            <div className="tajweed-modules__list-wrapper">
              <ul className="tajweed-modules__list">
                {[
                  "The different types of Quran letters and their pronunciation.",
                  "The rules of Waqf (stopping) and how to properly pause and continue recitation.",
                  "The characteristics of each letter and how to articulate them properly.",
                  "The rules of Madd (lengthening) and how to elongate certain sounds.",
                  "The rules of Idgham (merging) and how to merge two or more sounds together.",
                  "The rules of Qalqalah (vibration) and how to pronounce letters with a slight vibration.",
                  "The rules of Noon and Meem Sakinah (nasalization) and how to properly nasalize these letters.",
                  "The rules of Raa (pronunciation) and how to properly pronounce this letter.",
                  "The rules of Huroof Muqata'at.",
                  "The rules of Tashdeed (Shaddah).",
                  "The rules of Alif Sakinah and Leen (soft letters).",
                  "The Rules of Hamzah.",
                  "The rules of Waqooful Quran.",
                  "The rules of Tarqiq (Light Letters)."
                ].map((moduleText, index) => (
                  <li key={index} className="tajweed-modules__item">
                    <svg className="tajweed-modules__checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    <span>{moduleText}</span>
                  </li>
                ))}
              </ul>
            </div>

            {/* Right Column: Image */}
            <div className="tajweed-modules__right">
              <div className="tajweed-modules__image-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/course1/Img-11.jpg`}
                  alt="Online Quran Tajweed Course - Al Quran Lesson"
                  className="tajweed-modules__img"
                />
              </div>
            </div>
          </div>
        </div>
      </section >

      {/* 4.76. Personalized Teaching & Feedback Section */}
      < section className="tajweed-teaching-section" >
        <div className="tajweed-teaching__container">
          <div className="tajweed-teaching__grid">
            {/* Column 1 */}
            <div className="tajweed-teaching__col">
              <div className="tajweed-teaching__header">
                <svg className="tajweed-teaching__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '22px', height: '22px', flexShrink: 0 }}>
                  <path fill="#006100" d="M512 64c0 113.6-84.6 207.5-194.2 222.4C305.9 423 194.7 512 64 512H32v-32c0-130.7 89-241.9 225.6-253.8C272.5 116.6 366.4 32 480 32h32z" />
                </svg>
                <h3 className="tajweed-teaching__title">Personalized Teaching</h3>
              </div>
              <p className="tajweed-teaching__desc">
                Students of different levels of proficiency and pace of learning Quran with Tajweed will be accommodated. Maximum individual attention and guidance from the instructors.
              </p>
            </div>

            {/* Column 2 */}
            <div className="tajweed-teaching__col">
              <div className="tajweed-teaching__header">
                <svg className="tajweed-teaching__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" style={{ width: '22px', height: '22px', flexShrink: 0 }}>
                  <path fill="#006100" d="M512 64c0 113.6-84.6 207.5-194.2 222.4C305.9 423 194.7 512 64 512H32v-32c0-130.7 89-241.9 225.6-253.8C272.5 116.6 366.4 32 480 32h32z" />
                </svg>
                <h3 className="tajweed-teaching__title">Feedback and Assessment:</h3>
              </div>
              <p className="tajweed-teaching__desc">
                Students will receive regular feedback and assessment from the instructor to monitor their progress and identify areas for improvement. Regular assessments, quizzes or recitation tests, to evaluate student learning and provide motivation for continued progress.
              </p>
            </div>
          </div>
        </div>
      </section >
      <CertifiedTutors />

      {/* SECTION 2: A Decade Of Quranic Education */}
      <section className="journey-parallax-section timeline-journey" id="timeline-journey">
        <div className="journey-parallax-section__container" style={{ maxWidth: '1600px', margin: '0 auto' }}>
          <div className="timeline-journey__badge">Our Journey</div>

          <h2 className="timeline-journey__title">
            A Decade Of Quranic Education
          </h2>

          <p className="timeline-journey__subtitle">
            From a small online classroom in 2013 to over 5,000 students across the USA, UK, and Canada. Here's how we grew.
          </p>

          <div className="timeline-journey__steps-container">
            {/* 2013 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2013</h3>
              <h4 className="timeline-journey__step-title">Founded</h4>
              <p className="timeline-journey__step-desc">
                Al Quran Lesson launched with 3 certified tutors and a mission to make Quranic education accessible from home.
              </p>
            </div>

            {/* 2017 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2017</h3>
              <h4 className="timeline-journey__step-title">1,000+ Students</h4>
              <p className="timeline-journey__step-desc">
                Reached our first major milestone, 1,000 active students across the USA and UK with a team of 20+ tutors.
              </p>
            </div>

            {/* 2021 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2021</h3>
              <h4 className="timeline-journey__step-title">3,000+ Students</h4>
              <p className="timeline-journey__step-desc">
                Expanded to Canada and began offering specialized Hifz and Tajweed programs for advanced learners.
              </p>
            </div>

            {/* 2024 */}
            <div className="timeline-journey__step">
              <div className="timeline-journey__icon-wrapper">
                <svg className="timeline-journey__icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M17 10.43V2H7v8.43c-1.2.75-2 2.07-2 3.57 0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4 0-1.5-.8-2.82-2-3.57zM12 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                </svg>
              </div>
              <h3 className="timeline-journey__step-year">2024</h3>
              <h4 className="timeline-journey__step-title">5,000+ Students</h4>
              <p className="timeline-journey__step-desc">
                Now serving 5,000+ students with 20+ certified male and female tutors, rated 4.6★ with 5,000+ reviews.
              </p>
            </div>
          </div>
        </div>
      </section>



      {/* Benefits Header Banner Section */}
      <section
        className="tajweed-benefits-header-section"
        style={{
          '--bg-url': `url('${process.env.PUBLIC_URL}/assets/images/green-bg.png')`
        }}
      >
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div className="about-features__badge-wrapper" style={{ display: 'inline-flex', justifyContent: 'center', margin: '0 auto 16px auto', backgroundColor: 'rgba(0, 130, 66, 0.08)', border: '1px solid rgba(0, 130, 66, 0.15)', padding: '6px 16px', borderRadius: '50px', color: '#006100' }}>
            <svg className="about-features__badge-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style={{ width: '18px', height: '18px', fill: '#006100', marginRight: '6px' }}>
              <path d="M0 480c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V160H0v320zm579.16-192c17.86-17.39 28.84-37.34 28.84-58.91 0-52.86-41.79-93.79-87.92-122.9-41.94-26.47-80.63-57.77-111.96-96.22L400 0l-8.12 9.97c-31.33 38.45-70.01 69.76-111.96 96.22C233.79 135.3 192 176.23 192 229.09c0 21.57 10.98 41.52 28.84 58.91h358.32zM608 320H192c-17.67 0-32 14.33-32 32v128c0 17.67 14.33 32 32 32h32v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h64v-72c0-48 48-72 48-72s48 24 48 72v72h64v-64c0-17.67 14.33-32 32-32s32 14.33 32 32v64h32c17.67 0 32-14.33 32-32V352c0-17.67-14.33-32-32-32zM64 0S0 32 0 96v32h128V96c0-64-64-96-64-96z" />
            </svg>
            <span style={{ fontWeight: '600' }}>Benefits</span>
          </div>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', marginBottom: '16px', color: '#0b2a18', fontFamily: 'Poppins, sans-serif' }}>
            Why Al Quran Lesson's Online Tajweed Course is the Best For You?
          </h2>
          <p style={{ fontSize: '1.1rem', color: '#4a5568', margin: '0', lineHeight: '1.6' }}>
            Hundreds of families across the United States have chosen Al Quran Lesson for their Quran Tajweed classes online. Here's why:
          </p>
        </div>
      </section>

      {/* Benefits Content Section */}
      <section className="about-features" id="tajweed-benefits" style={{ paddingTop: '60px' }}>
        <div className="about-features__container" style={{ maxWidth: '1600px', margin: '0 auto' }}>


          <div className="about-features__grid">
            {/* Left Column: Features 1-3 */}
            <div className="about-features__col about-features__col--left">
              {/* Feature 01 */}
              <div className="about-features__item about-features__item--left">
                <div className="about-features__badge">01</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">3-Day Free Trial</h3>
                  <p className="about-features__item-desc">
                    Try our Tajweed classes completely free for 3 days, no payment, no credit card, no commitment, just real live sessions with a certified tutor before you decide.
                  </p>
                </div>
              </div>

              {/* Feature 02 */}
              <div className="about-features__item about-features__item--left">
                <div className="about-features__badge">02</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Certified Tajweed Tutors</h3>
                  <p className="about-features__item-desc">
                    Learn from qualified Quran teachers who possess extensive knowledge of Tajweed rules, Quranic pronunciation, and recitation techniques. Their personalized guidance helps students correct mistakes and develop confidence in every lesson.
                  </p>
                </div>
              </div>

              {/* Feature 03 */}
              <div className="about-features__item about-features__item--left">
                <div className="about-features__badge">03</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Separate Classes for Sisters</h3>
                  <p className="about-features__item-desc">
                    Female students are taught exclusively by our certified female Qarias in a private, comfortable, and fully modest learning environment, no exceptions.
                  </p>
                </div>
              </div>
            </div>

            {/* Middle Column: Dome/Arch Capsule Image */}
            <div className="about-features__image-col">
              <div className="about-features__image-wrapper">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/About.avif`}
                  alt="Online Quran Classes For Adults"
                  className="about-features__img"
                />
              </div>
            </div>

            {/* Right Column: Features 4-6 */}
            <div className="about-features__col about-features__col--right">
              {/* Feature 04 */}
              <div className="about-features__item about-features__item--right">
                <div className="about-features__badge">04</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Live Classes</h3>
                  <p className="about-features__item-desc">
                    Every session is a live, interactive class with your dedicated tutor, not a pre-recorded video, so your pronunciation gets corrected in real time, every lesson.
                  </p>
                </div>
              </div>

              {/* Feature 05 */}
              <div className="about-features__item about-features__item--right">
                <div className="about-features__badge">05</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Structured Tajweed Program</h3>
                  <p className="about-features__item-desc">
                    Our curriculum follows a step-by-step learning path covering pronunciation, articulation points, recitation rules, and practical exercises. Students build a strong foundation before advancing toward more comprehensive Tajweed applications.
                  </p>
                </div>
              </div>

              {/* Feature 06 */}
              <div className="about-features__item about-features__item--right">
                <div className="about-features__badge">06</div>
                <div className="about-features__text">
                  <h3 className="about-features__item-title">Flexible Scheduling</h3>
                  <p className="about-features__item-desc">
                    Choose any days and times that fit your routine, morning, evening, or weekend with full availability across all USA time zones around the clock.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '40px' }}>
            <a href="/free-trial/" className="btn-green-cta-large" style={{ display: 'inline-block', backgroundColor: '#006400', color: '#ffffff', padding: '14px 32px', borderRadius: '40px', fontWeight: '700', textDecoration: 'none', fontSize: '0.95rem', transition: 'all 0.3s ease' }}>
              Get Free Trial For Classes &rarr;
            </a>
          </div>
        </div>
      </section>



      {/* Start Your Free Quranic Journey Today Section */}
      <section className="tajweed-journey-bottom-text" style={{ padding: '80px 24px', backgroundColor: 'transparent', textAlign: 'center' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <h2 style={{ fontSize: '2.4rem', fontWeight: '800', color: '#0b2a18', marginBottom: '24px', fontFamily: 'Poppins, sans-serif' }}>
            Start Your Free Quranic Journey Today
          </h2>
          <p style={{ fontSize: '1.05rem', color: '#333333', lineHeight: '1.8', margin: '0 auto', maxWidth: '1100px' }}>
            <a href="/free-trial/" className="green-link" style={{ color: '#006100', textDecoration: 'underline', fontWeight: '600' }}>Get a free trial</a> lesson of our Quran recitation classes so that you can learn about our strategy before registering. Join today to learn the Quran with Tajweed in a supportive and interactive online community. Start your spiritual travel with our <a href="/quran-reading-classes-online-for-kids-and-adults/" className="green-link" style={{ color: '#006100', textDecoration: 'underline', fontWeight: '600' }}>Quran recitation classes</a>, which are trusted by students from the United States. We have flexible hours (as per your convenience) and superb teachers; it’s very easy to learn from your own place. Whether you want to learn Tajweed or enroll in a <a href="/quran-memorization-classes-course/" className="green-link" style={{ color: '#006100', textDecoration: 'underline', fontWeight: '600' }}>Quran memorization course</a>, we have reputable male and female teachers.
          </p>
        </div>
      </section>

      {/* Consultation Section */}
      <ConsultationSection />

      {/* FAQ Section */}
      <section className="faq-section" id="tajweed-faq">
        <div className="faq-section__container" style={{ maxWidth: '1600px', margin: '0 auto' }}>
          <div className="faq-section__grid">
            {/* Left Column */}
            <div className="faq-section__col faq-section__col--left">
              <h2 className="faq-section__title">
                Frequently Asked Questions About Our Online Tajweed Course in the USA
              </h2>
              <p className="faq-section__subtitle">You might have questions about our online Quran Tajweed classes, we have answers for all of these.</p>

              <div className="faq-section__accordion">
                {[
                  {
                    id: 'tj-left-0',
                    question: "Is there a free trial before I commit to paying?",
                    answer: "Yes! Al Quran Lesson offers a 3-day free trial for all new students, both kids and adults. You get real, live classes with a qualified tutor, completely free and with no credit card required. It’s the best way to experience the teaching style, meet your tutor, and decide if the course is the right fit for you or your kids, with zero risk."
                  },
                  {
                    id: 'tj-left-1',
                    question: "Do you offer online Tajweed classes for kids?",
                    answer: "Absolutely. We offer dedicated Tajweed classes for children as young as 4 to 5 years old. Kids’ classes are shorter (30 minutes), more interactive, and designed to hold a child’s attention with patience and encouragement. Female tutors are available for young girls. Start with our 3-day free trial to see how your child responds before enrolling."
                  },
                  {
                    id: 'tj-left-2',
                    question: "Do you have female tutors for sisters?",
                    answer:
                      (<>
                        Yes. We have qualified female tutors, including <a style={{ color: "#006100" }} href="/our-tutors/qaria-sadaf-sarfaraz/">Qaria Sadaf Sarfaraz</a> and <a style={{ color: "#006100" }} href="/our-tutors/aalima-qaria-yousra/">Aalima Qaria Yousra</a>, who teach female students exclusively. You can request a female tutor when booking your free trial, and we will match you accordingly.
                      </>)
                  }
                ].map((faq) => (
                  <div key={faq.id} className={`faq-item ${faqOpenStates[faq.id] ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => setFaqOpenStates({ [faq.id]: !faqOpenStates[faq.id] })}
                      aria-expanded={faqOpenStates[faq.id]}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column */}
            <div className="faq-section__col faq-section__col--right">
              <div className="faq-section__accordion">
                {[
                  {
                    id: 'tj-right-0',
                    question: "Can I get classes that fit my schedule in the USA?",
                    answer: "Yes. Classes are available 7 days a week across all US time zones, EST, CST, MST, and PST. Whether you prefer early mornings, evenings, or weekends, we schedule around your life. You can also reschedule a class with advance notice if something comes up."
                  },
                  {
                    id: 'tj-right-1',
                    question: "Will I receive a certificate after completing the course?",
                    answer: "Yes. Students receive a course completion certificate upon finishing the Tajweed course. For those interested in a formal Ijaazah, a chain of certification linking back to the Prophet ﷺ, our advanced-level tutors can guide you through that process as a next step after the course."
                  },
                  {
                    id: 'tj-right-2',
                    question: "Do I need any prior knowledge to start?",
                    answer: "No prior Tajweed or Arabic knowledge is required. Our online Tajweed classes are open to complete beginners. We assess your level during the free trial and start from exactly where you are, whether you’ve never opened the Quran before or you have already read but want to fix your pronunciation."
                  },
                  {
                    id: 'tj-right-3',
                    question: "How do the online classes actually work?",
                    answer: "All classes are live, one-on-one sessions held via Zoom or Google Meet. Your tutor listens to your recitation in real time, corrects mistakes on the spot, and gives personalized feedback. You need nothing more than a phone or laptop and a stable internet connection; no special equipment required."
                  },
                  {
                    id: 'tj-right-4',
                    question: "How long does it take to learn Tajweed?",
                    answer: "Most students notice clear improvement within 2–3 months of regular classes. A solid foundation covering all Tajweed rules typically takes 4–6 months. The pace depends on your practice between sessions, but our tutors always move at a speed that’s comfortable for you"
                  },
                  {
                    id: 'tj-right-5',
                    question: "Can adults learn Tajweed online, even if they already recite the Quran?",
                    answer: "Yes, and it’s very common. Many adults in the USA have been reciting the Quran for years with pronunciation habits that are technically incorrect. Our adult Tajweed course identifies and corrects those habits, refines your recitation, and builds consistency. It is never too late to improve."
                  },
                  {
                    id: 'tj-right-6',
                    question: "What are the fees for the Tajweed course?",
                    answer: (<>
                      Our fee packages are designed to be affordable for families in the USA. Pricing is based on the number of classes per week and duration. Monthly packages are available with 3, 4, or 5 classes per week. Visit our <a style={{ color: "#006100" }} href="/quran-classes-fee/">Fee Packages</a> for full details, or simply book the free 3-day trial first, and our team will walk you through everything with no pressure.
                    </>)
                  }
                ].map((faq) => (
                  <div key={faq.id} className={`faq-item ${faqOpenStates[faq.id] ? 'faq-item--open' : ''}`}>
                    <button
                      className="faq-item__header"
                      onClick={() => setFaqOpenStates({ [faq.id]: !faqOpenStates[faq.id] })}
                      aria-expanded={faqOpenStates[faq.id]}
                    >
                      <span>{faq.question}</span>
                      <svg className="faq-item__icon" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <div className="faq-item__body">
                      <div className="faq-item__content">
                        <p>{faq.answer}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

    </div >
  );
};

export default TajweedCourse;

